import styled from 'vue-styled-components';

import {
    FLEX_CENTER_DIV,
    FLEX_COLUMN_DIV,
    FLEX_DIV,
} from '@/styles/common.styled.component';

export const Wrapper = styled(FLEX_COLUMN_DIV)`
    gap: 16px;
`;

export const GroupSet = styled(FLEX_COLUMN_DIV)`
    position: relative;
    padding: 12px 8px 8px 8px;
    gap: 6px;

    border-radius: 8px;
    border: 1px dashed var(--color-gray-40);
`;

export const GroupIdLabel = styled.div`
    position: absolute;
    left: 8px;
    right: 8px;
    top: -9px;
    padding: 2px 6px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    color: var(--color-green-60);
    font-size: 13px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: -0.25px;
`;

export const Group = styled(FLEX_COLUMN_DIV, { depth: Number })`
    gap: 6px;
    overflow: hidden;

    ${({ depth }) =>
        depth >= 1 &&
        ` 
      flex: 1;
      padding: 8px;
      border-radius: 8px;
      border: 1px dashed var(--color-gray-40);
      background: var(--color-gray-5); 
    `};
`;

export const GroupRow = styled(FLEX_DIV)`
    gap: 8px;
`;

export const GroupOperator = styled.div`
    flex-shrink: 0;

    color: var(--color-gray-100);
    font-size: 13px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.2px;
`;

export const Item = styled(FLEX_DIV)`
    padding: 4px 6px;
    gap: 4px;
    overflow: hidden;

    border-radius: 4px;
    background: var(--color-gray-20);
`;

export const ItemField = styled.div`
    flex-shrink: 0;

    color: var(--color-gray-100);
    font-size: 13px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: -0.25px;
`;

export const ItemOperator = styled.div`
    flex-shrink: 0;

    color: var(--color-gray-70);
    font-size: 13px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: -0.25px;
`;

export const ItemValues = styled(FLEX_COLUMN_DIV)`
    gap: 2px;
    overflow: hidden;
`;

export const ItemValue = styled(FLEX_DIV)`
    overflow: hidden;
    gap: 2px;
`;
export const ItemValueText = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    color: var(--color-gray-90);
    font-size: 13px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: -0.25px;
`;
export const ItemValueLogo = styled(FLEX_CENTER_DIV)`
    flex-shrink: 0;

    &,
    & > * {
        width: 14px;
        height: 14px;
    }
`;
export const Tooltip = styled.div`
    color: var(--color-gray-100);
    font-size: 11px;
    white-space: pre-line;
    word-break: keep-all;
`;
